module.exports = __webpack_public_path__ + "img/1@2x.0f975b8b.png";